import { Component, Inject, Injector, Input, OnInit, Optional } from '@angular/core';
import { ReportsUsersGroupsPermissionsComponent } from '../reports-users-groups-permissions/reports-users-groups-permissions.component';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { ReportsUsersGroupsPermissionsService } from '../../_services/reports-users-groups-permissions.service';
import { Report } from '../../_types/report';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
    selector: 'app-reports-users-groups-permissions-list',
    templateUrl: './reports-users-groups-permissions-list.component.html',
    styleUrls: ['./reports-users-groups-permissions-list.component.css'],
    standalone: false
})
export class ReportsUsersGroupsPermissionsListComponent implements OnInit {

  public usersPermissions: any[] = [];
  public groupsPermissions: any[] = [];
  @Input() public report: Report | undefined;
  public loading: boolean = false;
  private dynamicDialogConfig?: DynamicDialogConfig;


  constructor( 
    private dialogService: DialogService,
    private reportsUsersGroupsPermissions: ReportsUsersGroupsPermissionsService,
    private injector: Injector,
    private confirmationService: ConfirmationService,
    private reportsUsersGroupsPermissionsService: ReportsUsersGroupsPermissionsService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    try {
      this.dynamicDialogConfig = this.injector.get(DynamicDialogConfig);
      if (this.dynamicDialogConfig.data.report != null) this.report = this.dynamicDialogConfig.data.report;
    } catch (e) {
      //nothign to do
    }
    this.loadPermissions(this.report?.id!);
  }


    async editUserGroupPermission(type: string, reportUserGroupPermission: any) {
      let ref = this.dialogService.open(ReportsUsersGroupsPermissionsComponent, {
        closable: true,
        modal: true,
        header: 'Editar permisos',
        width: '500px',
        data: {
          reportUserGroupPermissionId: reportUserGroupPermission ? reportUserGroupPermission.id : null,
          reportId: this.report?.id,
          type: type
        }
      });
  
      ref.onClose.subscribe((data: any) => {
        this.loadPermissions(this.report?.id!);
      });
    }
  
    async deleteUserGroup(userGroupPermission:any){
      this.confirmationService.confirm({
        message: `¿Está seguro que desea eliminar al usuario ${userGroupPermission.user?.name}?`,
        header: "Eliminar permisos",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.reportsUsersGroupsPermissionsService.delete(userGroupPermission.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Permiso eliminado correctamente." });
              this.loadPermissions(this.report?.id!);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }

    async loadPermissions(id: string) {
      this.loading = true;
      let filters:any = {};
        filters.reportId = new Filter(FilterOperation.equals, 'reportId', '', id);
              
      let params: IParamsCollection = {      
        filter: FilterBuilder.fromObject(filters).build(),
        include: ['user', 'group']            
      };
      
      let response = await firstValueFrom(this.reportsUsersGroupsPermissions.all(params));
      this.usersPermissions = response.data.filter((m:any) => m.userId != null);
      this.groupsPermissions = response.data.filter((m:any) => m.groupId != null);
      this.loading = false;
    }



}
